'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Importación de las Actions.
 */
import {
    GET_SCREEN_DATA_EDITPERMISOS_STARTS,
    SET_USER_FUNCTIONS_EDITPERMISOS,
    GET_SCREEN_DATA_EDITPERMISOS_SUCCESS,
    RESET_STATE_EDITPERMISOS,
    SELECT_PRODUCTO_EDITPERMISOS,
    SELECT_CATEGORIA_EDITPERMISOS,
    SELECT_PROGRAMA_EDITPERMISOS,
    ELIMINAR_FUNCION_EDITPERMISOS,
    AGREGAR_FUNCION_EDITPERMISOS,
    ELIMINAR_HISTORIAL_EDITPERMISOS,
    SELECCIONAR_HISTORIAL_EDITPERMISOS,
    ESCONDER_POPUP_EDITPERMISOS,
    REDIRECT_OK_EDITPERMISOS,
    EDITPERMISOS_FAIL
} from '../../Screens/EditarPermisos/actions/EditarPermisos';

/**
 * Estado inicial.
 */
const initialState = {
    isFetching: true,
    redirect: false,

    //Funciones de seguridad
    functions: [],

    productos: [],
    categorias: [],
    programas: [],
    perfiles: [],
    historial: [],

    //Funciones para mostrar
    funciones_tabla: [],
    funciones_perfil: [],

    //Filtro de combos
    filter: {
        product: 0,
        category: 0,
        program: 0,
        activate: false
    },

    //PopUp
    message: "",
    messageClass: "",
    messageHidden: true
};

/**
 * Variables globales del reducer
 */
let result, perfiles, estado, response;

/**
 * 
 * @param {any} state
 * @param {any} action
 */
function editarPermisos(state = initialState, action) {

    function ordenarPerfilesAlfabeticamente(arrayPerfiles){
        arrayPerfiles = arrayPerfiles.sort(function (a, b) {
            if (a.Codigo.toLowerCase() > b.Codigo.toLowerCase()) {
                a.first = false;
                b.first = false;
                return 1;
            }
            if (a.Codigo.toLowerCase() < b.Codigo.toLowerCase()) {
                a.first = false;
                b.first = false;
                return -1;
            }
            return 0; 
        });
        arrayPerfiles[0].first = true;
        return arrayPerfiles;
    }

    switch (action.type) {
        case GET_SCREEN_DATA_EDITPERMISOS_STARTS:
            LogHelper.In(editarPermisos.name, action, state);

            result = {
                ...state,
                isFetching: true
            };
            break;

        case SET_USER_FUNCTIONS_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case GET_SCREEN_DATA_EDITPERMISOS_SUCCESS:
            LogHelper.In(editarPermisos.name, action, state);
            action.result.GET_PERFILES = ordenarPerfilesAlfabeticamente(action.result.GET_PERFILES);
            result = {
                ...state,
                productos: action.result.GET_PRODUCTOS,
                categorias: action.result.GET_CATEGORIAS,
                programas: action.result.GET_PROGRAMAS,
                perfiles: action.result.GET_PERFILES,
                historial: [],
                isFetching: false
            };
            break;

        case RESET_STATE_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            result = initialState;
            break;

        case SELECT_PRODUCTO_EDITPERMISOS:{
            LogHelper.In(editarPermisos.name, action, state);
            perfiles = JSON.parse(JSON.stringify(state.perfiles));

            perfiles.forEach(function (perfil) {
                perfil.functions = [];
            });
            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            let funciones_tabla = [];//(parseInt(action.id) == 0 ? [] : state.funciones_tabla);

            result = {
                ...state,
                funciones_tabla,
                perfiles: perfiles,
                filter: {
                    product: parseInt(action.id),
                    category: 0,
                    program: 0,
                    activate: false
                }
            };
            break;
        }

        case SELECT_CATEGORIA_EDITPERMISOS:{
            LogHelper.In(editarPermisos.name, action, state);

            perfiles = JSON.parse(JSON.stringify(state.perfiles));

            perfiles.forEach(function (perfil) {
                perfil.functions = [];
            });
            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            let funciones_tabla = [];

            result = {
                ...state,
                funciones_tabla,
                perfiles: perfiles,
                filter: {
                    product: state.filter.product,
                    category: parseInt(action.id),
                    program: 0,
                    activate: false
                }
            };
            break;
        }
        case SELECT_PROGRAMA_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            perfiles = estado.perfiles;

            perfiles.forEach(function (perfil) {
                perfil.functions = action.result.funciones_perfil.filter(x => x.PerfilId == perfil.Id);
            });

            perfiles = _recargarTabla(estado.filter.product, estado.filter.category, action.result.id, estado.historial, perfiles);

            sessionStorage.setItem('PantallaCambios', estado.historial.length > 0);

            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            result = {
                ...state,
                perfiles: perfiles,
                funciones_tabla: action.result.funciones_tabla,
                funciones_perfil: action.result.funciones_perfil,
                filter: {
                    product: state.filter.product,
                    category: state.filter.category,
                    program: parseInt(action.result.id),
                    activate: true
                }
            };
            break;

        case ELIMINAR_FUNCION_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            response = _eliminarFuncion(estado, action.perfilId, action.funcion);

            sessionStorage.setItem('PantallaCambios', response.historial.length > 0);


            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            result = {
                ...state,
                perfiles: response.perfiles,
                historial: response.historial
            };

            break;

        case AGREGAR_FUNCION_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            response = _agregarFuncion(estado, action.perfilId, action.funcion);

            sessionStorage.setItem('PantallaCambios', response.historial.length > 0);

            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            result = {
                ...state,
                perfiles: response.perfiles,
                historial: response.historial
            };
            break;

        case ELIMINAR_HISTORIAL_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));

            perfiles = estado.perfiles;
            perfiles.forEach(function (perfil) {
                perfil.functions = estado.funciones_perfil.filter(x => x.PerfilId == perfil.Id);
            });

            response = _eliminarHistorial(estado, action.historialId);
            sessionStorage.setItem('PantallaCambios', response.historial.length > 0);
            perfiles = ordenarPerfilesAlfabeticamente(perfiles);
            result = {
                ...state,
                perfiles: response.perfiles,
                historial: response.historial
            };
            break;

        case SELECCIONAR_HISTORIAL_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            estado = JSON.parse(JSON.stringify(state));
            perfiles = estado.perfiles;
            perfiles.forEach(function (perfil) {
                perfil.functions = action.response.funciones_perfil.filter(x => x.PerfilId == perfil.Id);
            });

            perfiles = _recargarTabla(action.response.productoId, action.response.categoriaId, action.response.programaId, estado.historial, perfiles);

            sessionStorage.setItem('PantallaCambios', estado.historial.length > 0);

            perfiles = ordenarPerfilesAlfabeticamente(perfiles);

            result = {
                ...state,
                perfiles: perfiles,
                funciones_perfil: action.response.funciones_perfil,
                filter: {
                    product: action.response.productoId,
                    category: action.response.categoriaId,
                    program: action.response.programaId,
                    activate: true
                }
            };
            break;

        case REDIRECT_OK_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            result = {
                ...state,
                isFetching: false,
                redirect: true
            };
            break;

        case EDITPERMISOS_FAIL:
            LogHelper.In(editarPermisos.name, action, state);

            result = {
                ...state,
                isFetching: false,
                message: action.message,
                messageClass: "error",
                messageHidden: false
            };
            break;

        case ESCONDER_POPUP_EDITPERMISOS:
            LogHelper.In(editarPermisos.name, action, state);

            result = {
                ...state,
                message: "",
                messageClass: "",
                messageHidden: true
            };
            break;

        default:
            result = { ...state };
            break;
    }

    LogHelper.Out(editarPermisos.name, result);

    return result;
}

export default editarPermisos;

/** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

/**
 * Agrega una o todas las funciones en el historial, dependiendo el perfil y producto/categoria/programa.
 * @param {any} estado
 * @param {any} perfilId
 * @param {any} funcion
 */
function _agregarFuncion(estado, perfilId, funcion) {
    LogHelper.In(_agregarFuncion.name, estado, perfilId, funcion);

    let producto = JSON.parse(JSON.stringify(estado.productos.find(x => x.Id == estado.filter.product)));
    let categoria = JSON.parse(JSON.stringify(estado.categorias.find(x => x.Id == estado.filter.category)));
    let programa = JSON.parse(JSON.stringify(estado.programas.find(x => x.Id == estado.filter.program)));

    let perfilHistorial;

    if (funcion.Id == 0) {        
        estado.funciones_tabla.forEach(function (funcion) {
            if (funcion.Id != 0 && (!estado.perfiles.find(x => x.Id == perfilId).functions.find(x => x.Id == funcion.Id))) {
                estado.perfiles.find(x => x.Id == perfilId).functions.push({
                    Id: funcion.Id,
                    Codigo: funcion.Codigo,
                    Descripcion: funcion.Descripcion,
                    PerfilId: perfilId
                });

                perfilHistorial = JSON.parse(JSON.stringify(estado.perfiles.find(x => x.Id == perfilId)));
                perfilHistorial.functions.find(x => x.Id == funcion.Id).Agregada = true;

                let existeHistorial = estado.historial.find(x => x.producto.Id === parseInt(estado.filter.product)
                    && x.categoria.Id === parseInt(estado.filter.category)
                    && x.programa.Id === parseInt(estado.filter.program));

                if (existeHistorial) {
                    let existeHistorialIndex = estado.historial.findIndex(x => x.producto.Id === parseInt(estado.filter.product)
                        && x.categoria.Id === parseInt(estado.filter.category)
                        && x.programa.Id === parseInt(estado.filter.program));
                    let perfilIndex = existeHistorial.perfiles.findIndex(x => x.Id === perfilId);

                    if (perfilIndex < 0) {
                        existeHistorial.perfiles.push(perfilHistorial);
                    }
                    else {
                        let funcionHistorial = existeHistorial.perfiles.find(x => x.Id === perfilId).functions.find(x => x.Id == funcion.Id);

                        if (funcionHistorial) {
                            funcionHistorial.Agregada = true;
                            funcionHistorial.Eliminada = false;
                        }
                        else {
                            existeHistorial.perfiles[perfilIndex].functions.push({
                                Id: funcion.Id,
                                Codigo: funcion.Codigo,
                                Descripcion: funcion.Descripcion,
                                PerfilId: perfilId,
                                Agregada: true
                            });
                        }
                    }

                    estado.historial[existeHistorialIndex] = existeHistorial;
                }
                else {
                    let history = {
                        id: estado.historial.length > 0 ? estado.historial[estado.historial.length - 1].id + 1 : estado.historial.length + 1,
                        perfiles: [],
                        producto: producto,
                        categoria: categoria,
                        programa: programa
                    };

                    history.perfiles.push(perfilHistorial);
                    estado.historial.push(history);
                }
            }
        });
    }
    else {
        estado.perfiles.find(x => x.Id == perfilId).functions.push({
            Id: funcion.Id,
            Codigo: funcion.Codigo,
            Descripcion: funcion.Descripcion,
            PerfilId: perfilId
        });

        perfilHistorial = JSON.parse(JSON.stringify(estado.perfiles.find(x => x.Id == perfilId)));
        perfilHistorial.functions.find(x => x.Id == funcion.Id).Agregada = true;

        let existeHistorial = estado.historial.find(x => x.producto.Id === parseInt(estado.filter.product)
            && x.categoria.Id === parseInt(estado.filter.category)
            && x.programa.Id === parseInt(estado.filter.program));

        if (existeHistorial) {
            let existeHistorialIndex = estado.historial.findIndex(x => x.producto.Id === parseInt(estado.filter.product)
                && x.categoria.Id === parseInt(estado.filter.category)
                && x.programa.Id === parseInt(estado.filter.program));
            let perfilIndex = existeHistorial.perfiles.findIndex(x => x.Id === perfilId);

            if (perfilIndex >= 0) {
                let funcionHistorial = existeHistorial.perfiles[perfilIndex].functions.find(x => x.Id == funcion.Id);
                if (funcionHistorial) {
                    funcionHistorial.Agregada = true;
                    funcionHistorial.Eliminada = false;                    
                }
                else {
                    existeHistorial.perfiles[perfilIndex].functions.push({
                        Id: funcion.Id,
                        Codigo: funcion.Codigo,
                        Descripcion: funcion.Descripcion,
                        PerfilId: perfilId,
                        Agregada: true
                    });
                }                
            }
            else {
                existeHistorial.perfiles.push(perfilHistorial);
            }

            estado.historial[existeHistorialIndex] = existeHistorial;
        }
        else {
            let history = {
                id: estado.historial.length + 1,
                perfiles: [],
                producto: producto,
                categoria: categoria,
                programa: programa
            };

            history.perfiles.push(perfilHistorial);
            estado.historial.push(history);
        }
    }

    LogHelper.Out(_agregarFuncion.name, {perfiles: estado.perfiles, historial: estado.historial});

    return {
        perfiles: estado.perfiles,
        historial: estado.historial
    };
}

/**
 * Elimina una funcion en el historial, dependiendo el perfil y producto/categoria/programa.
 * @param {any} estado
 * @param {any} perfilId
 * @param {any} funcion
 */
function _eliminarFuncion(estado, perfilId, funcion) {
    LogHelper.In(_eliminarFuncion.name, estado, perfilId, funcion);

    let producto = JSON.parse(JSON.stringify(estado.productos.find(x => x.Id == estado.filter.product)));
    let categoria = JSON.parse(JSON.stringify(estado.categorias.find(x => x.Id == estado.filter.category)));
    let programa = JSON.parse(JSON.stringify(estado.programas.find(x => x.Id == estado.filter.program)));
    let funcionExistente = _validacionFuncionExistente(perfilId, funcion.Id, estado.filter, estado.historial);    

    if (!funcionExistente) {
        let existeHistorial = estado.historial.find(x => x.producto.Id === parseInt(estado.filter.product)
            && x.categoria.Id === parseInt(estado.filter.category)
            && x.programa.Id === parseInt(estado.filter.program));

        estado.perfiles.find(x => x.Id == perfilId).functions.find(x => x.Id == funcion.Id).Eliminada = true;

        if (existeHistorial) {
            let existeHistorialIndex = estado.historial.findIndex(x => x.producto.Id === parseInt(estado.filter.product)
                && x.categoria.Id === parseInt(estado.filter.category)
                && x.programa.Id === parseInt(estado.filter.program));
            let perfilIndex = existeHistorial.perfiles.findIndex(x => x.Id === perfilId);

            if (perfilIndex >= 0) {
                existeHistorial.perfiles[perfilIndex].functions.push({
                    Id: funcion.Id,
                    Codigo: funcion.Codigo,
                    Descripcion: funcion.Descripcion,
                    PerfilId: perfilId,
                    Eliminada: true
                });
            }
            else {
                existeHistorial.perfiles.push(estado.perfiles.find(x => x.Id == perfilId));
            }

            estado.historial[existeHistorialIndex] = existeHistorial;
        }
        else {
            let history = {
                id: estado.historial.length + 1,
                perfiles: [],
                producto: producto,
                categoria: categoria,
                programa: programa
            };

            history.perfiles.push(estado.perfiles.find(x => x.Id == perfilId));
            estado.historial.push(history);
        }
    }
    else {
        funcionExistente.Agregada = false;
        funcionExistente.Eliminada = true;        
    }

    let perfiles = JSON.parse(JSON.stringify(estado.perfiles));
    perfiles.find(x => x.Id == perfilId).functions.splice(
        estado.perfiles.find(x => x.Id == perfilId).functions.findIndex(x => x.Id == funcion.Id), 1); 

    LogHelper.Out(_eliminarFuncion.name, {perfiles: perfiles, historial: estado.historial});

    return {
        perfiles: perfiles,
        historial: estado.historial
    };
}


/**
 * Valida que la funcion a eliminar exista en el historial
 * @param {any} perfilId
 * @param {any} funcionId
 * @param {any} filtro
 * @param {any} historial
 */
function _validacionFuncionExistente(perfilId, funcionId, filtro, historial) {
    LogHelper.In(_validacionFuncionExistente.name, perfilId, funcionId, filtro, historial);

    let historialCopy = historial.find(x => x.producto.Id === parseInt(filtro.product)
        && x.categoria.Id === parseInt(filtro.category)
        && x.programa.Id === parseInt(filtro.program));

    if (historialCopy !== undefined) {
        let perfil = historialCopy.perfiles.find(y => y.Id === parseInt(perfilId));
        if (perfil !== undefined) {
            let func = perfil.functions.find(z => z.Id === funcionId);

            LogHelper.Out(_recargarTabla.name, perfil);

            if (func !== undefined) {
                return func;
            } else {
                return undefined
            }
        } else {
            LogHelper.Out(_recargarTabla.name);
            return undefined
        }
    } else {
        LogHelper.Out(_recargarTabla.name);
        return undefined;
    }
}

/**
 * Elimina un registro entero del array de historiales
 * @param {any} estado
 * @param {any} historialId
 */
function _eliminarHistorial(estado, historialId) {
    LogHelper.In(_eliminarHistorial.name, estado, historialId);

    let index = estado.historial.findIndex(x => x.id === historialId);

    if (index > -1) {
        estado.historial.splice(index, 1);

        estado.perfiles = _recargarTabla(estado.filter.product, estado.filter.category, estado.filter.program, estado.historial, estado.perfiles);
    }

    LogHelper.Out(_recargarTabla.name, {perfiles: estado.perfiles, historial: estado.historial});

    return {
        perfiles: estado.perfiles,
        historial: estado.historial
    };
}

/**
 * Recarga la tabla una vez ejecutada una accion
 * @param {any} productoId
 * @param {any} categoriaId
 * @param {any} programaId
 * @param {any} historial
 * @param {any} perfiles
 */
function _recargarTabla(productoId, categoriaId, programaId, historial, perfiles) {
    LogHelper.In(_recargarTabla.name, productoId, categoriaId, programaId, historial, perfiles);

    let historialFiltrado = historial.find(x => x.producto.Id === parseInt(productoId)
        && x.categoria.Id === parseInt(categoriaId)
        && x.programa.Id === parseInt(programaId));

    if (historialFiltrado) {
        perfiles.forEach(function (perfil) {        
            let perfilHistorial = historialFiltrado.perfiles.find(x => x.Id == perfil.Id);

            if (perfilHistorial) {
                perfilHistorial.functions.forEach(function (funcion) {
                    let funcionHistorial = perfil.functions.find(x => x.Id === funcion.Id);

                    if (funcionHistorial) {
                        if (funcion.Eliminada == true) {
                            let indexFuncionHistorial = perfil.functions.findIndex(x => x.Id === funcion.Id);

                            perfil.functions.splice(indexFuncionHistorial, 1);
                        }
                    }
                    else {
                        if (funcion.Agregada == true) {
                            let indexFuncionHistorial = perfil.functions.findIndex(x => x.Id === funcion.Id);

                            perfil.functions.push({
                                Id: funcion.Id,
                                Codigo: funcion.Codigo,
                                Descripcion: funcion.Descripcion,
                                PerfilId: perfil.Id
                            });
                        }
                    }
                });
            }
        });
    }
    LogHelper.Out(_recargarTabla.name, perfiles);
    return perfiles;
}